import { ReactElement } from 'react';

import Paragraph from '@/shared/Paragraph/ui/Paragraph';
import * as S from './Content.styles';
import { ContentHeader } from '@/common/app/constants/constants';
import Layout from '@/shared/Layout/ui/Layout';
import { TPageContent } from './Content.types';
import { Block } from '@/common/ui/containers/Block';
import { CommonMeta } from '@/common/ui/meta/CommonMeta';
import { buildRootUrl } from '@/common/app/utils/urlsUtils';

export type ContentPageProps = {
    pageContent: TPageContent;
};

const ContentPage = ({ pageContent }: ContentPageProps): ReactElement => {
    const { title, slug } = pageContent;
    const canonical = buildRootUrl(slug);

    return (
        <Layout>
            <CommonMeta
                {...pageContent}
                ogDescription={pageContent?.description || ContentHeader}
                canonical={canonical}
            />
            <Block data-test-id="ContentPage">
                <S.Title id="ts_title">{title}</S.Title>
                <Paragraph
                    className="table-layout"
                    id="ts_paragraph"
                    as="div"
                    innerHtml={pageContent.content}
                />
            </Block>
        </Layout>
    );
};

export default ContentPage;
